<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="synopsis">
<h1>Synopsis</h1>
<p>A magical, mystical tale of a turbulent and, at times, violent and tragic past-life memory of a life once lived in a land called Scythia around 2400 B.C., of a half Scythian, half Mongolian Hun Warrior called ‘Manu Kai’, who was the second son of a Scythian tribal Chieftain, and who also belonged to a secretive and mysterious brotherhood otherwise known as ‘The Agari’.</p>
<p>Our hero’s story begins with a chance encounter with a charismatic market trader, who gives him an ancient Scythian relic, which has the effect of triggering a past life memory of his early childhood in Scythia, and his struggle growing up against a backdrop of the constant threat of war, and of the racist bullying which he experienced as a result of being the first half Mongolian, half Scythian child born into his settlement, and of his very first encounter with the head of the Agari, who would later become his mentor and teacher.</p>
<p>The story continues to unfurl into a mystical world of self-discovery, and as he grows into adulthood, it goes on to tell of his personal inner struggle with trying to combine his duty as a Warrior, and a future leader of his people, with his role as an Agari priest. And also of his endearing friendships, his lovers, personal trials, and initiations, into the Magical Brotherhood of the Agari, and his brutal and continuing conflict with the early Roman/Italian army, which persisted throughout his extraordinary life.</p>
<p>Rich with historical fact – this book will take you on a rollercoaster journey into a long-ago forgotten land, where brave warrior fought against brave warrior, but dragons were never slain, as they were seen as wise and all powerful, and anyway…they only existed in another dimension.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?085c562e